import { PageNavigation } from '##/utils/PageNavigation';
import { focusCache } from '##/services/store/store';

export const deepLinkSignIn = async (): Promise<void> => {
  focusCache.activationScreen.$set({
    signInDeeplinked: true,
  });
  PageNavigation.replaceRoute('/sign-in');
};
